export const transformarJSON = (json) => {
    // Obtiene la clave original (por ejemplo "banco", "cuenta", etc.)
    const originalKey = Object.keys(json)[0];

    // Retorna un nuevo objeto con la clave "dato"
    return {
        dato: json[originalKey] // Mantiene el contenido original, solo cambia la clave
    };
};

export const formatCurrency = (amount) => {
    return `$${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
}